import {Trans} from '@lingui/macro';
import Avatar from '@material-ui/core/Avatar';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error from '@material-ui/icons/Error';
import Info from '@material-ui/icons/Info';
import PlayCircleFilled from '@material-ui/icons/PlayCircleFilled';
import List from 'devextreme-react/list';
import formatDate from 'features/dashboard/components/formatDate';
import {i18n2} from 'features/i18n/i18n';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {Redirect} from 'react-router-dom';
import {useLoadPendingCourseCustom} from '../hooks/useLoadPendingCourse';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    paddingLeft: '5%',
    paddingBottom: '5%',
  },
}));

const colors = {
  0: 'red',
  1: 'green',
  2: 'yellow',
};

const renderIcon = (status) => {
  switch (status) {
    case 0:
      return <Error />;
    case 1:
      return <CheckCircle />;
    case 2:
      return <PlayCircleFilled />;
    default:
      return <Info />;
  }
};

const HeaderMobile = ({status, title, count, children}) => {
  const classes = useStyles();
  const [color, setColor] = useState();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setColor(colors[status]);
  }, [status]);
  return (
    <>
      <Paper>
        <Grid
          container
          spacing={3}
          style={{display: 'flex'}}
          button
          onClick={() => setOpen(!open)}>
          <Grid item xs={8}>
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
            <Typography
              variant="subtitle2"
              style={{paddingLeft: '2vh'}}
              className={`${color}-text`}>
              <Trans>Cantidad total</Trans>: {count}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <ListItemAvatar>
              <Avatar className={`${color}-background`}>{renderIcon()}</Avatar>
            </ListItemAvatar>
          </Grid>
        </Grid>
      </Paper>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Paper>
          <div
            className={classes.root}
            style={{maxHeight: '55vh', minHeight: '55vh', overflow: 'auto'}}>
            {children}
          </div>
        </Paper>
      </Collapse>
    </>
  );
};

const HeaderDesktop = ({status, title, children}) => {
  const classes = useStyles();
  const [color, setColor] = useState();

  useEffect(() => {
    setColor(colors[status]);
  }, [status]);
  return (
    <Paper style={{height: '60vh'}}>
      <Grid container spacing={3} style={{display: 'flex'}}>
        <Grid item xs={8}>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <ListItemAvatar>
            <Avatar className={`${color}-background`}>{renderIcon()}</Avatar>
          </ListItemAvatar>
        </Grid>
        <Grid item xs={12} style={{paddingTop: 0}}>
          <div
            className={classes.root}
            style={{maxHeight: '50vh', minHeight: '50vh', overflow: 'auto'}}>
            {children}
          </div>
        </Grid>
      </Grid>
    </Paper>
  );
};

const ItemTemplate = (item, mobile = false) => {
  return (
    <div style={{width: '100%', whiteSpace: 'normal', padding: '5px'}}>
      <Typography
        variant="body1"
        className={`${colors[item.attended.status]}-text`}>
        {item.course.name}
      </Typography>
      <React.Fragment>
        <Typography variant="body2" color="textPrimary">
          {item.course.content}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {formatDate(item.instance, item.attended)}{' '}
          {item.attended.approved &&
            `- ${i18n2._('Fecha de realizacion')}: ${moment(
              item.attended.updateDate,
            ).format('DD/MM/YYYY')} - ${i18n2._('Puntaje')}: ${
              item.attended.score * 100
            }%`}
          {!mobile && item.instance.modality === 2 && (
            <div style={{color: 'red'}}>
              {i18n2._('Modalidad')}: {i18n2._('Papel')}
            </div>
          )}
        </Typography>
      </React.Fragment>
    </div>
  );
};

const Header = (props) => {
  return (
    <>
      {props.mobile ? (
        <HeaderMobile {...props} />
      ) : (
        <HeaderDesktop {...props} />
      )}
    </>
  );
};

export const PendingCourses = ({
  cwid,
  status,
  title,
  mobile = false,
  count = 0,
}) => {
  const datasource = useLoadPendingCourseCustom(cwid, status);
  const [redirect, setRedirect] = useState({active: false});
  const handleItemClick = ({itemData}) => {
    if (
      (itemData.attended.status === 0 || itemData.attended.status === 2) &&
      itemData.instance.modality !== 2
    ) {
      const expirationDate = moment(
        itemData.instance.expiration_Date,
        'YYYY-MM-DD',
      );
      var current = moment().startOf('day');
      setRedirect({
        active: true,
        iD_Course: itemData.course.iD_Course,
        iD_Instance: itemData.attended.iD_Instance,
        modality: 0,
        expired: moment.duration(expirationDate.diff(current)).asDays() < 0,
      });
    }
  };
  return (
    <div>
      <Header status={status} title={title} mobile={mobile} count={count}>
        <List
          dataSource={datasource}
          itemRender={(item) => ItemTemplate(item, mobile)}
          onItemClick={handleItemClick}
          width="100%"
          style={{overflow: 'auto'}}
          noDataText={''}
        />
      </Header>
      {redirect.active ? (
        <Redirect
          to={{
            pathname: './Capacitation',
            state: {
              iD_Course: redirect.iD_Course,
              iD_Instance: redirect.iD_Instance,
              modality: redirect.modality,
              expired: redirect.expired,
            },
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default PendingCourses;
